/**
 * @license
 * Copyright (c) 2017 - 2026 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import '@vaadin/icon/vaadin-icon.js';
import './version.js';
import './vaadin-iconset.js';
